/**
 * Routes centralisées de l'application
 * Toutes les routes doivent être définies ici pour éviter les doublons et les incohérences
 */

export const ROUTES = {
  // Routes publiques
  LOGIN: '/',
  PASSWORD_RESET_REQUEST: '/mot-de-passe-oublie',
  PASSWORD_RESET: '/reset-password',
  PASSWORD_RESET_CONFIRM: '/reset-password-confirm/:uid/:token',
  PUBLIC_PARTICIPATION: '/participate/:token',
  // ✅ NOUVEAU : Route SSO Callback
  SSO_CALLBACK: '/sso/callback',

  // Routes Admin
  ADMIN: {
    ROOT: '/admin',
    DASHBOARD: '/admin/dashboard',
    SURVEYS: '/admin/surveys',
    SURVEYS_VIEW: '/admin/surveys/:id',
    USERS: '/admin/utilisateurs',
    STATISTICS: '/admin/statistiques',
    JOURNALISATION: '/admin/journalisation',
    AUDIT_LOGS: '/admin/audit-logs',
    SURVEY_MANAGEMENT: '/admin/gestion-sondage',
  },

  // Routes Gérant
  GERANT: {
    ROOT: '/gerant',
    DASHBOARD: '/gerant/dashboard',
    SURVEYS: '/gerant/gestion-sondages',
    SURVEYS_NEW: '/gerant/gestion-sondages/nouveau',
    SURVEYS_VIEW: '/gerant/gestion-sondages/:id',
    SURVEYS_EDIT: '/gerant/gestion-sondages/modifier/:id',
    PARTICIPANTS: '/gerant/participants',
    MODELS: '/gerant/modeles',
  },

  // Routes Participant
  PARTICIPANT: {
    ROOT: '/participant',
    SURVEYS: '/participant/surveys',
    SURVEY_RESPOND: '/participant/survey/:id/respond',
    HISTORY: '/participant/history',
  },
};

/**
 * Obtient le rôle requis pour une route donnée
 * @param {string} path - Le chemin de la route
 * @returns {string|null} Le rôle requis ou null si la route est publique
 */
export const getRequiredRoleForRoute = (path) => {
  if (path.startsWith('/admin')) return 'admin';
  if (path.startsWith('/gerant')) return 'gerant';
  if (path.startsWith('/participant') || path.startsWith('/surveys') || path.startsWith('/survey')) return 'participant';
  return null; // Routes publiques
};

/**
 * Vérifie si une route est publique
 * @param {string} path - Le chemin de la route
 * @returns {boolean}
 */
export const isPublicRoute = (path) => {
  const publicRoutes = [
    ROUTES.LOGIN,
    ROUTES.PASSWORD_RESET_REQUEST,
    ROUTES.PASSWORD_RESET,
    ROUTES.PASSWORD_RESET_CONFIRM,
    ROUTES.PUBLIC_PARTICIPATION,
  ];
  return publicRoutes.some(route => {
    // Gère les routes avec des paramètres
    const routeRegex = new RegExp(`^${route.replace(/:[^/]+/g, '[^/]+')}/?$`);
    return routeRegex.test(path);
  });
};
